import { CrudState } from "@/store/crud/State";

export class State extends CrudState {
  images: any[] = [];
  isImagesLoading = false;

  consumptionData: any[] = [];
  isConsumptionDataLoading = false;
}
